import { colors, layout } from '../../NewHire/v2/styles';

interface FinishedReviewCardProps {
  employeeName: string;
  signedPdfUrl: string | null;
}

const FinishedReviewCard = ({ employeeName, signedPdfUrl }: FinishedReviewCardProps) => {
  return (
    <div style={layout.page}>
      <div style={{ ...layout.container, maxWidth: 640 }}>
        <div style={{ ...layout.card, textAlign: 'center', padding: '48px 32px' }}>
          <div style={{ fontSize: 48, color: colors.success, marginBottom: 12 }}>
            <i className="fas fa-check-circle" />
          </div>
          <h1 style={{ fontSize: 22, fontWeight: 700, margin: 0 }}>Annual review complete</h1>
          <p style={{ color: colors.muted, marginTop: 10 }}>
            The signed annual review is now available in {employeeName}&apos;s performance tab.
          </p>
          {signedPdfUrl ? (
            <a
              href={signedPdfUrl}
              target="_blank"
              rel="noreferrer"
              style={{
                display: 'inline-block',
                marginTop: 16,
                color: colors.accent,
                fontWeight: 600,
                textDecoration: 'none',
              }}
            >
              <i className="fas fa-download" /> Download signed PDF
            </a>
          ) : null}
        </div>
      </div>
    </div>
  );
};

export default FinishedReviewCard;
